import { useQuery } from "@tanstack/react-query";
import { supabaseAgency } from "@/lib/supabase";

export interface ClientKpiRow {
  client: string;
  roas?: number;
  cpm?: number;
  spend_pace?: number;
  delta_roas?: number;
  revenue_per_recipient?: number;
  open_rate?: number;
  delta_rpr?: number;
  synced_at?: string;
}

export function useKpi() {
  return useQuery<ClientKpiRow[]>({
    queryKey: ["kpi", "all-clients"],
    queryFn: async () => {
      const { data, error } = await supabaseAgency
        .from("os_client_kpi_cache").select("*");
      if (error) throw error;
      return (data ?? []).map((r: any) => ({ ...r, client: r.client_id }));
    },
    refetchInterval: 5 * 60_000,
  });
}
